import React, { Component } from 'react';
import get from 'lodash/get';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import { Link } from 'gatsby';

import AboutRoom from './../components/about-room';
import BookingForm from './../components/booking-form';
import Footer from './../components/footer';
import HeroSlider from './../components/hero-slider';
import NavSection from './../components/nav-section';
import Layout from './../components/layout';
// import RedroomEventsSection from './../components/redroom-events';
import VirtualTour from './../components/virtual-tour';



export class BackGardenArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      moveMsg: '',
    };
  }

  load() {
    this.setState({ msg: 'Interact with image !' });
  }
  render() {
    const navMenus = get(this, 'props.data.allContentfulNavigation.edges');
    const {
      title,
      header,
      aboutThisRoom,
      floor,
      size,
      capacity,
      floorPlan,
      slideImages,
      virtualTourLink,
      link,
      linkText,
      imageMap,
      imageMapWidth
    } = get(this, 'props.data.allContentfulVenues.edges')[0].node;
const footer = get(this, 'props.data.allContentfulFooter.edges')
    const bookingForm = get(this, 'props.data.allContentfulBookingForm.edges')[0].node;
    const newSlideImages = [];
    slideImages.map(img => {
      newSlideImages.push({url: img.file.url})
    })

    return (
      <Layout>
        <div className="sm-transNav">
          <NavSection navMenus={navMenus} navTheme="nav-transparent" />
        </div>
        <Helmet title={title} />
        <HeroSlider slides={newSlideImages} />
        <AboutRoom
          header={header}
          title={title}
          floor={floor}
          size={size}
          capacity={capacity}
          floorPlan={floorPlan.file.url}
          link={link}
          linkText={linkText}
          imageMap={JSON.parse(imageMap.internal.content)}
          imageMapWidth={imageMapWidth}
          bookingCta
          load={() => this.load()}
        >
          <p
            dangerouslySetInnerHTML={{
              __html: aboutThisRoom.aboutThisRoom
            }}
          ></p>
        </AboutRoom>
        {/* {link &&
                  <div className="btn-toursform container mb90">
                  <div className="row">
                    <div className="col-12 text-left">
                      <Link to={link}>
                        <button className="btn">{linkText}</button>
                      </Link>
                    </div>
                  </div>
                </div>
          } */}
        {/* <VirtualTour url={virtualTourLink} /> */}
        <VirtualTour url="https://exsight360.com/virtual-tours/palacio-de-memoria/v8/tour.html" />
        {/* <RedroomEventsSection room={title} /> */}
        <BookingForm bookingForm={bookingForm}/>
         <Footer 
          footer={footer}
        />
      </Layout>
    );
  }
}
//commented out
// allContentfulRoomBackGarden {
//   edges {
//     node {
//       title
//       aboutThisRoom {
//         aboutThisRoom
//       }
//       floor
//       size
//       capacity
//       floorPlan {
//         file {
//           url
//         }
//       }
//     }
//   }
// }

export default BackGardenArea;

export const pageQuery = graphql`
  query Venues($slug: String) {
    site {
      siteMetadata {
        title
      }
    }

    allContentfulVenues(filter: {slug: {eq: $slug}}) {
      edges {
        node {
          title
          slug
          header
          aboutThisRoom {
            aboutThisRoom
          }
          capacity
          floor
          floorPlan {
            file {
              url
            }
          }
          size
          slideImages {
            file {
              url
            }
          }
          virtualTourLink
          link
          linkText
          imageMap {
            internal {
              content
            }
          }
          imageMapWidth
        }
      }
    }
    allContentfulBookingForm {
      edges {
        node {
          header
          firstNameInputPlaceholder
          lastNameInputPlaceholder
          contactNoInputPlaceholder
          emailInputPlaceholder
          bookingTypeInputPlaceholder {
            name
            value
          }
          dateInputPlaceholder
          timeInputPlaceholder
          venueInputPlaceholder {
            name
            value
            selected_value
          }
          messageInputPlaceholder
          newsletterInputPlaceholder
          submitInputPlaceholder
        }
      }
    }
    allContentfulNavigation(sort: { fields: createdAt }) {
      edges {
        node {
          id
          slug
          pageTitle
          submenu
        }
      }
    }
    allContentfulFooter {
      edges {
        node {
          facebookLink
          footerAddress
          footerEmail
          footerHeadline
          footerImage {
            file {
              url
            }
          }
          footerLandline
          footerMobileNumber
          footerOpeningDates
          footerOpeningHours
          instagramLink
          section
        }
      }
    }
  }
`;
